import { getPortalNamespace, storage } from "../../utils/auth";

function TokenUndefined(routevar) {
  const namespace = getPortalNamespace(window.location.pathname);
  const token = storage.get("token", namespace);
  
  if (token === "undefined" || !token) {
    if (namespace) {
      storage.clearNamespace(namespace);
    }
    window.location.href = `${process.env.REACT_APP_LOGIN_REDIRECTION_URL}/${routevar}`;
  }
}

export default TokenUndefined;
